import { useEffect } from 'react';
import { useAppDispatch } from '../../../../../app/hooks';
import { releaseReconciliations } from '../../../../../store/reconciliations/reconciliationsSlice';

/**
 * Releases one org's reconciliations cache on unmount / org change. Owned by the per-org page
 * container (Dashboard/index.tsx) — unconditionally mounted for the company view's whole
 * lifetime — rather than by the sidebar chip, which is itself conditionally rendered
 * (mobile-hidden, and gated by the drawer's visibility flag) and would otherwise leave a mobile
 * or flag-off session's cache entries never released even though the tab pills still populate them.
 */
export function useReleaseReconciliationsOnOrgChange(orgId: string | undefined): void {
    const dispatch = useAppDispatch();

    useEffect(() => {
        return () => {
            if (orgId) dispatch(releaseReconciliations({ orgId }));
        };
    }, [dispatch, orgId]);
}
